module.exports = __webpack_public_path__ + "static/img/cp5.926c843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp5.png
// module id = lJZa
// module chunks = 0